<template>
<v-card
    v-if="show_card"
>
    <v-card-text>

        <v-row>
            <v-col
                style="flex-grow: 0"
            >
                <v-icon
                    size="100"
                >
                    mdi-calendar
                </v-icon>
            </v-col>
            <v-col>

                <m-restricted-field
                    v-if="this.$rc.$state.isAuthActorSystemAdmin()"
                >
                    <v-select
                        label="State"
                        :items="$rc.enumChoices('organization_event_state',false)"
                        v-model="summary.state"
                        v-on:change="onChangeState"
                    />
                </m-restricted-field>

                <m-restricted-field
                    v-if="this.$rc.$state.isAuthActorSystemAdmin() && summary.state == 'schedule-using-calendly'"
                >
                    <m-autocomplete
                        label="Schedule Using Calendly Link"
                        v-model="summary.schedule_using_calendly_event_type_uri"
                        endpoint="LIST: /api/v1/autocomplete/calendly-event-types"
                        :params="{'purpose': summary.purpose}"
                        v-on:input="onChangeCalendlyUri"
                        :clearable="false"
                    />
                </m-restricted-field>


                    <v-row v-if="this.$rc.$state.isAuthActorSystemAdmin() && summary.state == 'scheduled'">
                        <v-col>
                            <m-restricted-field>
                                <m-autocomplete
                                    label="Calendar Event"
                                    :value="summary.calendar_event_settings_id+':'+summary.calendar_event_id"
                                    endpoint="LIST: /api/v1/autocomplete/future-calendar-events"
                                    v-on:input="onChangeEvent"
                                    :clearable="false"
                                    ref="calendar-link-autocomplete"
                                />
                            </m-restricted-field>

                            <m-edit-calendar-event-dialog
                                ref="edit-calendar-event"
                                v-on:update="afterCreateEvent"
                            />
                        </v-col>

                        <v-col
                            style="flex-grow: 0;"
                        >
                            <v-menu
                                bottom
                                offset-y
                            >

                            <template v-slot:activator="{ on }">

                                <v-icon
                                    v-on="on"
                                    style="margin-top: 15px"
                                >
                                    mdi-dots-vertical-circle-outline
                                </v-icon>

                            </template>

                            <v-list>
                                <m-restricted-menu-list-item
                                    v-on:click="onClickCreateEvent()"
                                    text="Create Event..."
                                />

                                <m-restricted-menu-list-item
                                    v-on:click="onClickEditEvent()"
                                    :disabled="summary.calendar_event_settings_id == null || summary.calendar_event_id == null"
                                    text="Edit Event..."
                                />

                            </v-list>

                            </v-menu>


                        </v-col>
                    </v-row>

                <div
                    v-if="schedule_html != null"
                    v-html="schedule_html"
                >
                </div>

                <div
                    v-if="summary.state == 'scheduled' && summary.calendar_event_time_start != null"
                >
                    <div
                        style="font-size: 18px; font-weight: bold"
                    >
                        {{summary.calendar_event_title}}
                    </div>

                    <div
                        v-if="summary.calendar_event_body != null"
                        style="margin-top: 7px; margin-bottom: 7px"
                    >
                        {{summary.calendar_event_body}}
                    </div>


                    <div>
                        {{$rc.pretty(summary.calendar_event_time_start,'date')}} at {{$rc.pretty(summary.calendar_event_time_start,'time')}}
                    </div>
                    <div
                        v-if="summary.calendar_event_join_url != null"
                        style="margin-top: 15px"
                    >
                        To join: <a :href="summary.calendar_event_join_url" target="_blank">{{summary.calendar_event_join_url}}</a>
                    </div>
                </div>


            </v-col>
        </v-row>
    </v-card-text>
</v-card>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: function() { return null; }
        },
    },

    data() {
        return {
            summary: null,
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update()
        {
            if ( this.value == null )
            {
                this.summary = null;
                return;
            }

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/calendar/organization-events/:organization_id/:purpose',

                'params' : {
                        'organization_id': this.value.organization_id,
                        'purpose': this.value.purpose,
                    },

                'on_success': (data) => {
                        this.summary = data;
                    },

                'on_error': 'Unable to get event profile',
            });
        },

        patch(params)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PATCH: /api/v1/calendar/organization-events',

                'params' : {
                        ...params,
                        'organization_id': this.summary.organization_id,
                        'purpose': this.summary.purpose,
                    },

                'on_success': (data) => {
                        this.summary = data;
                        this.$emit('update');

                        if ( this.$refs['calendar-link-autocomplete'] != null )
                        {
                            this.$refs['calendar-link-autocomplete'].updateItems();
                        }
                    },

                'on_error': 'Unable to update event',
            });
        },

        onChangeState(new_state)
        {
            this.patch({'state': new_state});
        },

        onChangeCalendlyUri(uri)
        {
            this.patch({'schedule_using_calendly_event_type_uri': uri});
        },

        onChangeEvent(event_key)
        {
            this.patch({'future_calendar_event_key': event_key});
        },

        onClickCreateEvent()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/calendar/manual-event-stub',

                'params' : {
                    },

                'on_success': (data) => {
                        data.purpose = this.summary.purpose;
                        this.$refs['edit-calendar-event'].showDialog(data);
                    },

                'on_error': 'Unable to create stub calendar event',
            });
        },

        onClickEditEvent()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'LIST: /api/v1/calendar/events',

                'params' : {
                        'settings_id': this.summary.calendar_event_settings_id,
                        'event_id': this.summary.calendar_event_id
                    },

                'on_success': (data) => {
                        this.$refs['edit-calendar-event'].showDialog(data.results[0]);
                    },

                'on_error': 'Unable to edit calendar event',
            });


        },

        afterCreateEvent(event)
        {
            this.onChangeEvent(event.settings_id+':'+event.event_id);
        },
    },

    computed: {
        schedule_html() {

            if ( this.summary == null )
                return null;

            if ( this.summary.state != 'schedule-using-calendly' )
                return null;

            if ( this.summary.schedule_using_calendly_event_type_scheduling_url == null )
                return null;

            if ( this.summary.purpose == 'numbering-plan' )
            {
                return this.$rc.wrapHTML('Schedule a time to complete your numbering plan: '+this.summary.schedule_using_calendly_event_type_scheduling_url);
            }

            if ( this.summary.purpose == 'initial-training' )
            {
                return this.$rc.wrapHTML('Schedule a time for your initial RedChirp training: '+this.summary.schedule_using_calendly_event_type_scheduling_url);
            }

            return null;
        },

        show_card() {

            if ( this.summary == null )
                return false;

            if ( this.$rc.$state.isAuthActorSystemAdmin() )
                return true;

            return this.summary.state == 'scheduled' || this.summary.state == 'schedule-using-calendly';
        },
    },

    watch: {
        value() {
            this.update();
        }
    },
}
</script>

<style lang="scss" scoped>

</style>